import { Modal } from 'react-bootstrap'
import DotsLoading from 'components/loadings/dotsLoading'

/**
 * «آیا مایل به تسویه و خروج … هستید؟» — the confirmation, and nothing more.
 *
 * It used to own the checkout-status call as well, and did nothing with the
 * answer unless it was bad news, which is how «قبول» came to be a button that
 * closed a modal and stopped. Reading the member's balance and deciding what
 * happens next belongs to the page; this asks the question.
 */
export default function SettlementConfirmModal({
    show,
    onHide,
    name,
    lead = 'آیا مایل به تسویه و خروج',
    isChecking = false,
    onConfirm,
}: {
    show: boolean
    onHide: () => void
    name: string
    /** the question above the name; «هستید؟» follows it */
    lead?: string
    /** reading the member's balance — the modal stays up until it lands */
    isChecking?: boolean
    onConfirm: () => void
}) {
    return (
        <Modal
            show={show}
            onHide={isChecking ? () => {} : onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full py-4 text-center text-xs">
                <p className=" my-1">{lead}</p>
                <p className=" my-1 text-sm font-bold">{name}</p>
                <p className=" my-1">هستید؟</p>
                <hr />
                {isChecking ? (
                    <div className=" my-2">
                        <DotsLoading />
                        <p className=" mt-1 text-[11px] text-text-secondary">
                            در حال بررسی حساب عضو…
                        </p>
                    </div>
                ) : (
                    <>
                        <p className=" my-3 text-green-1" onClick={onConfirm}>
                            تایید
                        </p>
                        <hr />
                        <p className=" my-2" onClick={onHide}>
                            بستن
                        </p>
                    </>
                )}
            </div>
        </Modal>
    )
}
